import { ValueFormatterParams } from '@material-ui/data-grid';

import { displayDateTime, displayYesNo } from './text_formatters';

export const yesNoFormatter = (({ value }: ValueFormatterParams) => displayYesNo(value as boolean));
export const dateTimeFormatter = (({ value }: ValueFormatterParams) => displayDateTime(value as number));
export const disabledFormatter = (({ value }: ValueFormatterParams) => value ? 'DISABLED' : 'ENABLED');
